import React, { useEffect, useState } from "react";
import * as InitMapStore from "../../redux/store/init-map/init-map.store";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import OpenlayerMapView from "../../components/open-layer/open-layer";
import functionButton from "../init-map-data/function-button/function-button";
import * as mapAction from "../../redux/store/project-management/gid.store"
import * as appActions from "../../core/app.store";
import CreatMapView from "./create-map/create-map";
import InitMapView from "./init-map-view/init-map-view";
//import ListProject from "./list-project/list-project.view"
const ProjectManagement = (props) => {
    const { showLoading } = props;
    const planningId = 150;
    const mapId = 148;

    const [extend, setExtend] = useState([]);
    const [zoom, setZoom] = useState();
    const [mapLayer, setMapLayer] = useState();
    const [dataItems, setDataItem] = useState();
    const [isFist, setIsFist] = useState(false);
    const [baseMaps, setBaseMaps] = useState();
    const [layers, setLayers] = useState();
    const [mapSetting, setMapSetting] = useState();
    const [isOpenMap, setIsOpenMap] = useState(false);
    const [projectModel, setProjectModel] = useState([]);

    const handleCloseCreatMapModal = () => {
        return;
    };

    // const GetListAllConstructionInvestment = () => {
    //     showLoading(true)
    //     ProjectAction.GetListAllConstructionInvestment().then((res) => {
    //         setProjectModel(res && res.content);
    //         showLoading(false);
    //     }).catch(err => console.log(err));
    // }

    // useEffect(() => {
    //     GetListAllConstructionInvestment();
    // },[])

    return (
        <>
            <div className="row map_project_container">
                <div className="col-12 h-100">
                    <InitMapView mapId={mapId} planningId={planningId} isProject={true} />
                </div>
                {/* <CreatMapView
                    isProject={true}
                    open={true}
                    mapId={mapId}
                    planningId={planningId}
                    handleClose={() => handleCloseCreatMapModal()}
                    planningName={"test"}
                /> */}
            </div>
        </>
    )
}
const mapStateToProps = (state) => ({
    isLoading: state.app.loading,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            showLoading: appActions.ShowLoading,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManagement);
